$(function () {
  $('.c-table-outer').each(function () {
    $(this).prepend('<p class="mini-txt u-none u-block-sp u-mb-5">※ このテーブルは横スクロールができます</p>');
  });
  $('table:not([class])').each(function () {
    $(this).wrap('<div class="c-table-outer" />');
    $(this).parent().prepend('<p class="mini-txt u-none u-block-sp u-mb-5">※ このテーブルは横スクロールができます</p>');
  });
});